export const getPath = ({ pathname, search, hash }) => `${pathname}${search}${hash}`;
